import React from 'react'
import { Modal, Button } from 'antd'
import { ModalStyled } from './commonStyled'

const { Title, Description, Footer } = ModalStyled

export default function SessionTimeoutModal({ visible, onConfirm }) {
  return (
    <Modal
      open={visible}
      footer={null}
      bodyStyle={{ paddingBottom: 0 }}
      zIndex={1000}
      width={500}
      closable={false}
      maskClosable={false}
    >
      <Title>Session Expired</Title>
      <Description>
        Your session has expired due to inactivity. You have been logged out for security reasons.
      </Description>
      <Footer>
        <Button
          type="primary"
          onClick={onConfirm}
        >
        OK
        </Button>
      </Footer>
    </Modal>
  )
}
